/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
// import StatusFormatter from 'components/StatusFormatter';
import { FSBTable } from 'components/common/FSBTable';
import FSBModal from 'components/common/FSBModal';
import {
  SUBCATEGORY_LIST,
  SUBCATEGORY_LIST_SUBSCRIPTION,
  EXPORTS_SUB_CATEGORIES,
} from 'pages/Products/ProductsGraphQL';
import { subCategoryColumns } from 'pages/Products/constant';
import Loader from 'components/common/Loader';
import {
  ADD_EDIT_CONSTANT,
  USER_ID,
  defaultDeleteFilter,
  showSequenceNumber,
} from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import DownloadCSV from 'components/DownloadCSV';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { setUserDetails } from 'actions/userDetailsAction';
import ActionsFormatter from 'components/ActionsFormatter';
import { Button } from 'reactstrap';
import { IoMdAdd } from 'react-icons/io';
import ProductMobileList, {
  buildProductAuditSection,
  createdAtDetail,
} from 'pages/Products/components/ProductMobileList';
import SubCategoryDetails from './SubCategoryDetails';

const SubCategoryTable = ({
  searchString,
  toggleDeleteRecord,
  handleClickEdit,
  toggleAddRecord,
  selectedOption,
}) => {
  const dispatch = useDispatch();
  const defaultFilters = [
    {
      key: 'name',
      // joinAttributeName: '',
      value: searchString,
      type: 'STRING',
      op: 'LIKE',
    },
    { ...defaultDeleteFilter },
  ];

  const [filters, setFilters] = useState({
    filter: defaultFilters,
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    pagination: true,
  });
  const [showSubCategoryDetails, setShowSubCategoryDetails] = useState({
    status: false,
    row: null,
  });

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    SUBCATEGORY_LIST,
    {
      variables: {
        ...filters,
        filter: [...filters.filter],
      },
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: SUBCATEGORY_LIST_SUBSCRIPTION,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.subCategoryList.subCategoryList.findIndex(
          (val) =>
            val.id === subscriptionData.data?.subCategoryList?.subCategory?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.subCategoryList?.subCategory?.id)
          return prev;
        if (subscriptionData.data.subCategoryList.action === 'CREATED') {
          const newSubCategoryList =
            subscriptionData.data.subCategoryList.subCategory;
          const updatedSubCategoryList = [
            newSubCategoryList,
            ...newData.subCategoryList.subCategoryList,
          ];

          const newTotalCount = prev.subCategoryList.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.subCategoryList = {
            ...newData.subCategoryList,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            subCategoryList: updatedSubCategoryList,
          };
        }
        if (subscriptionData.data.subCategoryList.action === 'UPDATED') {
          newData.subCategoryList.subCategoryList[indexFound] =
            subscriptionData.data.subCategoryList.subCategory;
        }

        if (subscriptionData.data.subCategoryList.action === 'DELETED') {
          const { id } = subscriptionData.data.subCategoryList.subCategory; // ID of the category to remove
          const prevSubCategoryList = prev.subCategoryList.subCategoryList;

          const updatedSubCategoryList = prevSubCategoryList.filter(
            (val) => val.id !== id,
          );

          const newTotalCount = prev.subCategoryList.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedSubCategoryListData = {
            ...newData.subCategoryList,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            subCategoryList: updatedSubCategoryList,
          };

          newData.subCategoryList = updatedSubCategoryListData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (selectedOption?.id === 'all') {
      setFilters((old) => ({
        ...old,
        filter: [...defaultFilters],
        pageNo: 1,
        pageSize: 10,
      }));
    } else if (selectedOption?.id) {
      setFilters((old) => ({
        ...old,
        filter: [
          ...defaultFilters,
          {
            key: 'id',
            value: selectedOption?.id,
            joinAttributeName: 'product',
            innerAttributeName: 'id',
            op: 'EQ',
            type: 'INT',
          },
        ],
        pageNo: 1,
        pageSize: 10,
      }));
    }
  }, [selectedOption?.id]);

  // const [updateCategoryStatus] = useMutation(UPDATE_CATEGORY_STATUS, {
  //   // eslint-disable-next-line no-shadow
  //   onCompleted: () => {
  //     toast.success(STATUS_UPDATED_SUCCESSFULLY);
  //   },
  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.map(({ message }) => {
  //       return message;
  //     });
  //     toast.error(SOMETHING_WENT_WRONG);
  //   },
  // });

  // const handleStatusChange = async (e, cell) => {
  //   try {
  //     await updateCategoryStatus({
  //       variables: { id: cell?.row?.original?.id, status: e.target.value },
  //     });
  //     refetch();
  //   } catch (err) {
  //     toast.error(err);
  //   }
  // };

  // const statusFormatter = (cell) => {
  //   return (
  //     <StatusFormatter
  //       options={PRODUCT_STATUS}
  //       defaultValue={cell?.row?.original?.status}
  //       handleChange={(e) => handleStatusChange(e, cell)}
  //     />
  //   );
  // };

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        isDelete={false}
        handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
        // handleView={() => toggleShowDetails(cell?.row?.original)}
        handleEdit={() =>
          handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT)
        }
      />
    );
  };

  const toggleShowDetails = (row) => {
    setShowSubCategoryDetails((prev) => ({
      status: !prev.status,
      row: row ?? prev.row,
    }));
  };
  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => toggleShowDetails(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.name}
      </div>
    );
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return subCategoryColumns.findIndex((itm) => itm.accessorKey === item);
  };
  // subCategoryColumns[findIndexOfItem('status')].cell = statusFormatter;
  subCategoryColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  subCategoryColumns[findIndexOfItem('name')].cell = linkFormatter;
  subCategoryColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  subCategoryColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.CREATED_ID);
  subCategoryColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

  // const onDeleteConfirmation = async () => {
  //   const { id, email } = selectedUserRow;
  //   const rowId = selectedRows.map(({ original }) => original.id);
  //   const rowEmail = selectedRows.map(({ original }) => original.email);
  //   // await deleteUser({
  //   //   variables: {
  //   //     id: id ? [id] : rowId,
  //   //     email: email ? [email] : rowEmail,
  //   //   },
  //   // });

  //   setSelectedRows([]);
  //   setSelectedUserRow([]);
  //   setDeleteRecord(false);
  // };

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.subCategoryList?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.subCategoryList?.subCategoryList)
    return <NoDataFound message="Sector not available" />;

  return (
    <>
      <FSBModal
        size="xl"
        title="Sector Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showSubCategoryDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <SubCategoryDetails subCategoryDetails={showSubCategoryDetails.row} />
      </FSBModal>
      {/* <FSBModal
        size="xl"
        title="Categories Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer details-drawer"
      >
        <CategoriesDetails currentRowData={showDetails.row} />
      </FSBModal> */}
      {/* <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      /> */}
      <DownloadCSV
        lazyQuery={EXPORTS_SUB_CATEGORIES}
        filters={filters}
        apiKey="exportSubCategories"
        fileName="SubCategory"
        positionTop="-52px"
        positionRight="37px"
        classWrapper="products-download-btn"
      />{' '}
      <Button
        color="primary"
        className="position-absolute rounded-btn p-0 rounded-circle d-flex align-items-center justify-content-center products-add-btn"
        size="sm"
        onClick={toggleAddRecord}
        style={{ top: '15px', right: '20px' }}
      >
        <IoMdAdd color="#fff" size={20} />
      </Button>
      <ProductMobileList
        items={(data && data?.subCategoryList?.subCategoryList) || []}
        totalPages={(data && data?.subCategoryList?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        getTitle={(item) => item?.name || 'N/A'}
        getMeta={(item) =>
          `ID ${item?.id || 'N/A'} | ${item?.product?.name || 'N/A'}`
        }
        getSections={(item) => ({
          Overview: [
            { label: 'Product', value: item?.product?.name || 'N/A' },
            { label: 'Polymer', value: item?.productSubCategory || 'N/A' },
            createdAtDetail(item),
            { label: 'Status', value: item?.status || 'N/A', tone: 'status' },
          ],
          Audit: buildProductAuditSection(item),
        })}
        onTitleClick={toggleShowDetails}
        renderActions={(item) => actionsFormatter({ row: { original: item } })}
        handleUserId={handleUserId}
      />
      <div className="product-mobile-hide-table">
        <FSBTable
          data={(data && data?.subCategoryList?.subCategoryList) || []}
          totalCount={(data && data?.subCategoryList?.totalCount) || 0}
          totalPages={(data && data?.subCategoryList?.totalPages) || 0}
          columns={subCategoryColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Categories"
        />
      </div>
    </>
  );
};
export default SubCategoryTable;
